import { inWords } from "../../utils";
import _ from "lodash";
import moment from "moment";

export const pointToPointBillTemplate = (data) => {
  let { bills, startDate, endDate } = data;

  let rows = "";
  let clientName = "";
  bills.map((item) => {
    if (clientName == "") {
      clientName = item.party.accountName;
      return;
    }
  });
  bills.map((o, index) => {
    const isEligibleForIgst = !!o.party?.isEligibleForIgst;
    o.items.map((i, id) => {
      let { nameR, nameL, quantity, rate, amount, hsnCode, taxPercent } = i;
      let item = {
        nameR,
        nameL,
        quantity,
        index,
        rate,
        amount,
        hsnCode,
        taxPercent,
        isEligibleForIgst
      };

      if (id > 0) {
        rows = rows + renderTableRowIndex(item) + "\n";
      } else {
        rows = rows + renderTableRow(item) + "\n";
      }

      if (id + 1 == o.items.length) {
        rows = rows + renderTotalRow(o.code, o.createdAt) + "\n";
      }
    });
  });

  return `<!DOCTYPE html>
<html lang="en">
<head>
    <title>Challan 2</title>
    <meta charset="UTF-8">
    <style>
        * { box-sizing: border-box; }
        .border {
            border-style: solid;
            border-width: 1px;
        }

        .center {
            text-align: center;
            align-items: center;
            justify-content: center;
        }

        .row {
            display: flex;
            flex-direction: row;
            flex: 1;
        }

        .space-between {
            align-items: center;
            justify-content: space-between;
        }

        h2 {
            margin: 4px;
        }

        h4 {
            margin: 0;
            line-height: 1.25;
        }

        h3 {
            margin: 10px;
        }

        h5 {
            margin: 1px;
        }

        p {
            font-size: 14px;
            margin: 0;
            line-height: 1.25;
            overflow-wrap: anywhere;
            word-break: break-word;
        }

        table {
            table-layout: fixed;
            width: 100%;
            border-collapse: collapse;
            font-size: 9px;
        }
        table th, table td {
            font-weight: bold;
            border: 1px solid #000;
            padding: 4px 6px;
            vertical-align: top;
        }
        table thead th {
            white-space: nowrap;
            word-break: normal;
            overflow-wrap: normal;
        }
        table tbody td {
            word-break: break-word;
            overflow-wrap: break-word;
        }
        
        @media print {
            @page {
                size: A4;
                margin: 15mm;
            }
        }
    </style>
</head>
<body>

<div style="max-width: 210mm; margin: 0 auto;">
<div style="display:flex;flex:1;flex-direction:column;padding: 10px;">
<div style="display: flex;flex-direction: row;justify-content: space-between;flex-wrap: wrap;gap: 8px;align-items: flex-start;">
<h4 style="white-space: nowrap;">Bill</h4>
${startDate != null && endDate != null
      ? `<p>${moment(startDate).format("DD-MM-YYYY")} to ${moment(endDate).format(
        "DD-MM-YYYY"
      )}</p>`
      : ``
    }       
</div>
   
    <div style="display: flex;flex-direction: row;justify-content: space-between;flex-wrap: wrap;gap: 8px;align-items: flex-start;margin-top: 6px;">
    <h4 style="flex: 1;min-width: 0;overflow-wrap: anywhere;word-break: break-word;">M/S: ${clientName}</h4>
  
    </div>
   
  
    <div style="margin-top: 8px; overflow-x: auto;">
        <table>
            <thead>
            <tr>
                <th style="width: 4%;">Sr</th>
                <th style="width: 18%;">Description</th>
                <th style="width: 8%;">HSN</th>
                <th style="width: 6%;">Qty</th>
                <th style="width: 8%;">Rate</th>
                <th style="width: 9%;">Amount</th>
                <th style="width: 6%;">CGST%</th>
                <th style="width: 8%;">CGST</th>
                <th style="width: 6%;">SGST%</th>
                <th style="width: 8%;">SGST</th>
                <th style="width: 6%;">IGST%</th>
                <th style="width: 8%;">IGST</th>
            </tr>
            </thead>
            <tbody>
            ${rows}
            </tbody>
        </table>
    </div>
  
  
</div>
</body>
</html>

`;
};

let renderTableRow = (item) => {
  let { nameR, nameL, quantity, index, rate, amount, hsnCode, taxPercent, isEligibleForIgst } = item;
  const tax = Number(taxPercent) || 0;
  const amt = Number(amount) || 0;
  const cgstP = isEligibleForIgst ? 0 : tax / 2;
  const sgstP = isEligibleForIgst ? 0 : tax / 2;
  const igstP = isEligibleForIgst ? tax : 0;
  const cgstAmt = isEligibleForIgst ? 0 : (amt * tax) / 200;
  const sgstAmt = isEligibleForIgst ? 0 : (amt * tax) / 200;
  const igstAmt = isEligibleForIgst ? (amt * tax) / 100 : 0;

  return `<tr>
                <td style="width: 4%;">${index + 1}</td>
                <td style="width: 18%;">${escapeHtml(String(nameR || '') + ' ' + String(nameL || ''))}</td>
                <td style="width: 8%;">${escapeHtml(String(hsnCode || ''))}</td>
                <td style="width: 6%;">${quantity}</td>
                <td style="width: 8%;">${rate}</td>
                <td style="width: 9%;">${amount}</td>
                <td style="width: 6%;">${cgstP}</td>
                <td style="width: 8%;">${(cgstAmt).toFixed(2)}</td>
                <td style="width: 6%;">${sgstP}</td>
                <td style="width: 8%;">${(sgstAmt).toFixed(2)}</td>
                <td style="width: 6%;">${igstP}</td>
                <td style="width: 8%;">${(igstAmt).toFixed(2)}</td>
            </tr>`;
};

let renderTableRowIndex = (item) => {
  let { nameR, nameL, quantity, rate, amount, hsnCode, taxPercent, isEligibleForIgst } = item;
  const tax = Number(taxPercent) || 0;
  const amt = Number(amount) || 0;
  const cgstP = isEligibleForIgst ? 0 : tax / 2;
  const sgstP = isEligibleForIgst ? 0 : tax / 2;
  const igstP = isEligibleForIgst ? tax : 0;
  const cgstAmt = isEligibleForIgst ? 0 : (amt * tax) / 200;
  const sgstAmt = isEligibleForIgst ? 0 : (amt * tax) / 200;
  const igstAmt = isEligibleForIgst ? (amt * tax) / 100 : 0;

  return `<tr>
                <td style="width: 4%;"></td>
                <td style="width: 18%;">${escapeHtml(String(nameR || '') + ' ' + String(nameL || ''))}</td>
                <td style="width: 8%;">${escapeHtml(String(hsnCode || ''))}</td>
                <td style="width: 6%;">${quantity}</td>
                <td style="width: 8%;">${rate}</td>
                <td style="width: 9%;">${amount}</td>
                <td style="width: 6%;">${cgstP}</td>
                <td style="width: 8%;">${(cgstAmt).toFixed(2)}</td>
                <td style="width: 6%;">${sgstP}</td>
                <td style="width: 8%;">${(sgstAmt).toFixed(2)}</td>
                <td style="width: 6%;">${igstP}</td>
                <td style="width: 8%;">${(igstAmt).toFixed(2)}</td>
            </tr>`;
};

let renderTotalRow = (code, createdAt) => {
  //   let { code, createdAt } = item;

  return `<tr>
  <td style="width: 4%;"></td>
  <td style="width: 18%;" colspan="11">Dt: ${moment(createdAt).format("DD-MM-YYYY")} - ${escapeHtml(String(code || ''))}</td>
</tr>`;
};

function escapeHtml(str) {
  if (str == null) return '';
  return String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}
